module.exports = __webpack_public_path__ + "media/images/premium/icon-check-circle-d90dd7899946d502a56ffe2be299abfb.svg";